import {isDevMode, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {TranslateModule} from "@ngx-translate/core";

import {HttpProgressInterceptor} from "@commons/services/http.interceptor/http-progress-interceptor.service";

import {SharedModule} from "@shared/shared.module";
import {ShowTimeoutModalService} from "@shared/services/show-timeout-modal.service";
import {ShowErrorModalService} from "@shared/services/show-error-modal.service";
import {AppErrorHandler} from "@shared/error-handler";

import {LinksListComponent} from './routes/links-list/links-list.component';
import {LinkViewComponent} from './routes/link-view/link-view.component';
import {LinksListTableComponent} from './routes/links-list/components/links-list-table/links-list-table.component';
import {VehiclesListComponent} from './routes/link-view/components/vehicles-list/vehicles-list.component';
import {SelectedVehiclesComponent} from './routes/link-view/components/selected-vehicles/selected-vehicles.component';
import {LinkNameComponent} from './routes/link-view/components/link-name/link-name.component';
import {LinkActivityComponent} from './routes/link-view/components/link-activity/link-activity.component';
import {SearchInputComponent} from './routes/links-list/components/search-input/search-input.component';
import {AddedLinkModalComponent} from './routes/links-list/components/added-link-modal/added-link-modal.component';
import {
  ConfirmLinksRemovalModalComponent
} from './routes/links-list/components/confirm-links-removal-modal/confirm-links-removal-modal.component';
import {RootRouteComponent} from './routes/root-route/root-route.component';
import {IntegrationsComponent} from './routes/integrations/integrations.component';

@NgModule({
  declarations: [
    LinksListComponent,
    LinkViewComponent,
    LinksListTableComponent,
    VehiclesListComponent,
    SelectedVehiclesComponent,
    LinkNameComponent,
    LinkActivityComponent,
    SearchInputComponent,
    AddedLinkModalComponent,
    ConfirmLinksRemovalModalComponent,
    RootRouteComponent,
    IntegrationsComponent
  ],
  imports: [
    CommonModule,
    // DataSharingRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [
    RootRouteComponent,
  ]
})
export class DataSharingModule {

  constructor(
    private showTimeoutModalService: ShowTimeoutModalService,
    private showErrorModalService: ShowErrorModalService
  ) {
    if (isDevMode())
      console.log('DataSharingModule');

    this.subscribeToError();
    this.subscribeToHttpProgressInterceptorEvents();
  }

  private subscribeToError() {
    AppErrorHandler.$onError.subscribe(error => this.showErrorModalService.showModal(error));
  }

  private subscribeToHttpProgressInterceptorEvents() {
    HttpProgressInterceptor.$errorSubject.subscribe(() => this.showTimeoutModalService.showModal());
    HttpProgressInterceptor.$timeoutSubject.subscribe(() => this.showTimeoutModalService.showModal());
  }
}
